<template>
  <div v-if="vars.init.value">
    <dx-load-panel v-model:visible="vars.loading.value" :show-pane="true" />
    <div class="content-block">
      <div class="dx-card responsive-paddings back-colored">
        <div class="content-header">
          <dx-toolbar class="back-colored">
            <dx-item location="before">
              <div class="content-title">수주</div>
            </dx-item>
            <dx-item
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :options="{
                text: '신규',
                type: 'add',
                icon: 'add',
                disabled: vars.disabled.new,
                onClick: methods.newItem,
              }"
            />
            <dx-item
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :options="{
                text: '수정',
                type: 'rename',
                icon: 'rename',
                disabled: vars.disabled.edit,
                onClick: methods.editItem,
              }"
            />
            <dx-item
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :options="{
                text: '삭제',
                type: 'remove',
                icon: 'remove',
                disabled: vars.disabled.delete,
                onClick: methods.deleteItem,
              }"
            />
            <dx-item
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :options="{
                text: '저장',
                type: 'save',
                icon: 'save',
                disabled: vars.disabled.save,
                onClick: methods.saveItem,
              }"
            />
          </dx-toolbar>
        </div>
        <dx-form :form-data="vars.formData">
          <dx-group-item :col-count="5">
            <dx-group-item>
              <dx-simple-item
                data-field="order_number"
                :editor-options="{
                  placeholder: '(자동 or 직접입력)',
                  ...generateItemButtonOption(
                    'search',
                    methods.createFindPopupFn('order', '수주조회')
                  ),
                }"
              >
                <dx-label text="수주번호" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="order_date"
                editor-type="dxDateBox"
                :editor-options="{
                  dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ss',
                  ...vars.formState,
                }"
              >
                <dx-label text="수주일자" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="client_company"
                :editor-options="{
                  ...generateItemButtonOption(
                    'search',
                    methods.createFindPopupFn('client', '업체조회', {
                      name: vars.formData.client_company,
                    })
                  ),
                  ...vars.formState,
                  onEnterKey: methods.createFindPopupFn('client', '업체조회', {
                    name: vars.formData.client_company,
                  }),
                }"
              >
                <dx-label text="고객업체" :show-colon="false" />
                <dx-required-rule message="고객업체를 선택하세요" />
              </dx-simple-item>
              <dx-simple-item
                data-field="client_manager"
                editor-type="dxSelectBox"
                :editor-options="{
                  dataSource: vars.dataSource.client_manager,
                  displayExpr: 'name',
                  valueExpr: 'name',
                  acceptCustomValue: true,
                  disabled: vars.disabled.clientManager,
                  ...vars.formState,
                }"
              >
                <dx-label text="업체담당자" :show-colon="false" />
              </dx-simple-item>
            </dx-group-item>
            <dx-group-item>
              <dx-simple-item
                data-field="order_department"
                editor-type="dxSelectBox"
                :editor-options="{
                  dataSource: vars.dataSource.department,
                  displayExpr: 'department_name',
                  valueExpr: 'department_name',
                  acceptCustomValue: true,
                  onValueChanged: methods.onDepartmentChanged,
                  ...vars.formState,
                }"
              >
                <dx-label text="수주부서" :show-colon="false" />
                <dx-required-rule message="수주부서를 선택하세요" />
              </dx-simple-item>
              <dx-simple-item
                data-field="order_manager"
                editor-type="dxSelectBox"
                :editor-options="{
                  dataSource: vars.dataSource.employee,
                  displayExpr: 'emp_name',
                  valueExpr: 'emp_name',
                  disabled: vars.disabled.manager,
                  ...vars.formState,
                }"
              >
                <dx-label text="수주담당자" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="order_type"
                editor-type="dxSelectBox"
                :editor-options="{
                  dataSource: vars.dataSource.order_type,
                  displayExpr: 'code_name',
                  valueExpr: 'code_name',
                  ...vars.formState,
                }"
              >
                <dx-label text="수주구분" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="vat_type"
                editor-type="dxSelectBox"
                :editor-options="{
                  dataSource: vars.dataSource.vat_type,
                  displayExpr: 'code_name',
                  valueExpr: 'code_name',
                  onValueChanged: methods.onVatTypeChanged,
                  ...vars.formState,
                }"
              >
                <dx-label text="부가세구분" :show-colon="false" />
              </dx-simple-item>
            </dx-group-item>
            <dx-group-item>
              <dx-simple-item
                data-field="payment_terms"
                editor-type="dxSelectBox"
                :editor-options="{
                  dataSource: vars.dataSource.payment_terms,
                  displayExpr: 'code_name',
                  valueExpr: 'code_name',
                  acceptCustomValue: true,
                  ...vars.formState,
                }"
              >
                <dx-label text="결재조건" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="delivery_date"
                editor-type="dxDateBox"
                :editor-options="{
                  dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ss',
                  ...vars.formState,
                }"
              >
                <dx-label text="납품기한" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="delivery_place"
                editor-type="dxSelectBox"
                :editor-options="{
                  dataSource: vars.dataSource.delivery_place,
                  displayExpr: 'code_name',
                  valueExpr: 'code_name',
                  acceptCustomValue: true,
                  ...vars.formState,
                }"
              >
                <dx-label text="납품장소" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="client_order_number"
                :editor-options="{ ...vars.formState }"
              >
                <dx-label text="고객발주번호" :show-colon="false" />
              </dx-simple-item>
            </dx-group-item>
            <dx-group-item>
              <dx-simple-item
                data-field="project_number"
                :editor-options="{
                  ...generateItemButtonOption(
                    'search',
                    methods.createFindPopupFn('project', '프로젝트조회')
                  ),
                  ...vars.formState,
                }"
              >
                <dx-label text="프로젝트번호" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="end_user"
                :editor-options="{
                  ...generateItemButtonOption(
                    'search',
                    methods.createFindPopupFn('enduser', '고객조회')
                  ),
                  ...vars.formState,
                }"
              >
                <dx-label text="EndUser" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="note"
                :editor-options="{ ...vars.formState }"
              >
                <dx-label text="참고사항" :show-colon="false" />
              </dx-simple-item>
              <dx-simple-item
                data-field="confirmed"
                editor-type="dxCheckBox"
                :visible="false"
                :editor-options="{ onValueChanged: methods.onConfirmChanged }"
              >
                <dx-label text="수주확정" :show-colon="false" />
              </dx-simple-item>
            </dx-group-item>
            <dx-group-item>
              <dx-simple-item
                data-field="etc"
                editor-type="dxTextArea"
                :editor-options="{
                  ...generateItemButtonOption(
                    'rename',
                    methods.createFindPopupFn('etc', '비고', vars.formData.etc)
                  ),
                  ...vars.formState,
                  height: '174px',
                  labelMode: 'hidden',
                  placeholder: '비고',
                }"
              >
                <dx-label text="비고" :show-colon="false" :visible="false" />
              </dx-simple-item>
            </dx-group-item>
          </dx-group-item>
        </dx-form>
      </div>

      <div class="dx-card responsive-paddings mt-1">
        <div class="mt-2">
          <dx-data-grid
            class="fixed-header-table"
            height="calc(100vh - 416px)"
            :on-initialized="evt => methods.onGridInitialized(evt, 'item1')"
            :remote-operations="true"
            :data-source="vars.dataSource.item1"
            :show-borders="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-auto-width="true"
            :select-text-on-edit-start="true"
            :row-alternation-enabled="true"
            :focused-row-enabled="true"
            :disabled="vars.disabled.items"
            @saving="methods.onSavingItem"
            @data-error-occurred="methods.onDataError"
            @cell-dbl-click="methods.itemPopupClick"
            @focused-cell-changed="methods.onFocusedCellChanged"
          >
            <dx-grid-toolbar>
              <dx-item
                location="before"
                template="addFromQuote"
                :visible="!vars.formState.readOnly"
              />
              <dx-item
                location="before"
                template="addFromProject"
                :visible="!vars.formState.readOnly"
              />
              <dx-item
                location="before"
                template="calcAvailStock"
                :visible="!vars.formState.readOnly"
              />
              <dx-grid-item
                name="addRowButton"
                :options="{ onClick: methods.showAddPopup }"
              />
              <dx-grid-item name="saveButton" :visible="!!vars.formData.id" />
              <dx-grid-item name="revertButton" />
              <dx-grid-item name="columnChooserButton" />
            </dx-grid-toolbar>
            <template #addFromQuote>
              <dx-button
                icon="add"
                text="견적에서 가져오기"
                @click="methods.showAddQuotePopup"
              />
            </template>
            <template #addFromProject>
              <dx-button
                icon="add"
                text="프로젝트에서 가져오기"
                @click="methods.showAddProjectPopup"
              />
            </template>
            <template #calcAvailStock>
              <dx-button
                icon="formula"
                text="할당수량 재계산"
                @click="methods.calculateAssignQuantity"
              />
            </template>

            <dx-column
              data-field="item_code"
              caption="품목코드"
              width="180"
              :allow-editing="false"
            />
            <dx-column
              data-field="item.item_name"
              caption="품명"
              :allow-editing="false"
            />
            <dx-column
              data-field="item.item_standard"
              caption="규격"
              :allow-editing="false"
            />
            <dx-column
              data-field="order_quantity"
              caption="수주수량"
              data-type="number"
              format="fixedPoint"
              :set-cell-value="methods.setQuantity"
            />
            <dx-column
              data-field="assign_quantity"
              caption="할당수량"
              data-type="number"
              format="fixedPoint"
              :allow-editing="false"
            />
            <dx-column
              data-field="unit_price"
              caption="단가"
              data-type="number"
              format="currency"
              :set-cell-value="methods.setUnitPrice"
            />
            <dx-column
              data-field="item.unit"
              caption="단위"
              :allow-editing="false"
            />
            <dx-column
              data-field="supply_price"
              caption="공급가"
              data-type="number"
              format="currency"
              :allow-editing="false"
            />
            <dx-column
              data-field="request_delivery_date"
              caption="요청납기"
              data-type="date"
              format="yyyy-MM-dd"
            />
            <dx-column
              data-field="warehouse.wh_name"
              caption="출고창고"
              :set-cell-value="methods.setWarehouse"
            >
              <dx-lookup
                :data-source="vars.dataSource.warehouse"
                value-expr="wh_name"
                display-expr="wh_name"
              />
            </dx-column>
            <dx-column
              data-field="not_shipped"
              caption="미출고"
              data-type="number"
              format="fixedPoint"
              :allow-editing="false"
            />
            <dx-column
              data-field="basic_stock.available_stock"
              caption="가용재고"
              data-type="number"
              format="fixedPoint"
              :allow-editing="false"
              :allow-sorting="false"
              :calculate-display-value="methods.availableStock"
            />
            <dx-column
              data-field="basic_stock.current_stock"
              caption="현재고"
              data-type="number"
              format="fixedPoint"
              :allow-editing="false"
              :allow-sorting="false"
              :calculate-display-value="methods.currentStock"
            />
            <dx-column
              data-field="quote_number"
              caption="견적번호"
              :allow-editing="false"
            />
            <dx-column data-field="client_item_number" caption="고객사품번" />
            <dx-column
              data-field="item.item_detail"
              caption="품목설명"
              :allow-editing="false"
            />
            <dx-column data-field="note" caption="참고사항" />
            <dx-column
              data-field="closing_yn"
              caption="종결"
              data-type="boolean"
            />
            <dx-column
              data-field="project_number"
              caption="프로젝트번호"
              :editor-options="{
                ...generateItemButtonOption(
                  'search',
                  methods.createFindPopupFn('project2', '프로젝트조회')
                ),
              }"
            />
            <dx-column
              data-field="fk_order_id"
              caption="수주아이디"
              :visible="false"
              :allow-editing="false"
              :show-in-column-chooser="false"
            />
            <dx-column
              data-field="fk_quote_item_id"
              caption="견적품목아이디"
              :visible="false"
              :allow-editing="false"
              :show-in-column-chooser="false"
            />
            <dx-column
              data-field="warehouse_code"
              caption="창고코드"
              :visible="false"
              :allow-editing="false"
              :show-in-column-chooser="false"
            />

            <dx-editing
              :allow-adding="!vars.formState.readOnly"
              :allow-updating="!vars.formState.readOnly"
              :allow-deleting="!vars.formState.readOnly"
              mode="batch"
            />
            <dx-scrolling mode="standard" />
            <dx-column-chooser mode="select" :enabled="true" />
          </dx-data-grid>
        </div>
        <div class="mt-2">
          <table class="summary-table">
            <tr>
              <th>공급가:</th>
              <td>{{ vars.summary.supply_price.value }}</td>
              <th>부가세:</th>
              <td>{{ vars.summary.vat.value }}</td>
              <th>합계금액:</th>
              <td>{{ vars.summary.total_price.value }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <dx-popup
      v-model:visible="vars.dlg.addQuoteItem.show"
      content-template="popup-content"
      title="견적품목찾기"
      :close-on-outside-click="true"
      :width="680"
      :height="500"
      :resize-enabled="true"
      @initialized="evt => methods.onGridInitialized(evt, 'find-item-popup')"
    >
      <dx-toolbar-item
        widget="dxButton"
        toolbar="top"
        location="after"
        :options="{
          icon: 'add',
          text: '선택된 항목 추가',
          onClick: methods.addSelectedQuoteRows,
        }"
      />

      <template #popup-content>
        <dx-data-grid
          :on-initialized="evt => methods.onGridInitialized(evt, 'quoteItem')"
          :data-source="vars.dataSource.quoteItem"
          :show-borders="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :remote-operations="true"
        >
          <dx-column data-field="quote.client_company" caption="고객업체" />
          <dx-column data-field="quote.quote_number" caption="견적번호" />
          <dx-column
            data-field="quote.quote_date"
            caption="견적일자"
            data-type="date"
            format="yyyy-MM-dd"
          />
          <dx-column data-field="item_code" caption="품목코드" />
          <dx-column data-field="item.item_name" caption="품명" />
          <dx-column data-field="item.item_standard" caption="규격" />
          <dx-column
            data-field="quote_quantity"
            caption="견적수량"
            data-type="number"
            format="fixedPoint"
          />
          <dx-paging :page-size="20" />
          <dx-selection
            select-all-mode="page"
            show-check-boxes-mode="onClick"
            mode="multiple"
          />
          <dx-filter-row :visible="true" />
        </dx-data-grid>
      </template>
    </dx-popup>

    <dx-popup
      v-model:visible="vars.dlg.addProjectItem.show"
      content-template="popup-content"
      title="프로젝트 품목찾기"
      :close-on-outside-click="true"
      :width="680"
      :height="500"
      :resize-enabled="true"
      @initialized="evt => methods.onGridInitialized(evt, 'find-project-popup')"
    >
      <dx-toolbar-item
        widget="dxButton"
        toolbar="top"
        location="after"
        :options="{
          icon: 'add',
          text: '선택된 항목 추가',
          onClick: methods.addSelectedProjectRows,
        }"
      />

      <template #popup-content>
        <dx-data-grid
          :on-initialized="evt => methods.onGridInitialized(evt, 'projectItem')"
          :data-source="vars.dataSource.projectItem"
          :show-borders="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :remote-operations="true"
        >
          <dx-column
            data-field="project.project_number"
            caption="프로젝트번호"
          />
          <dx-column data-field="project.contract_name" caption="계약건명" />
          <dx-column data-field="project.order_company" caption="발주기관" />
          <dx-column data-field="item_code" caption="품목코드" />
          <dx-column data-field="item.item_name" caption="품명" />
          <dx-column
            data-field="quantity"
            caption="수량"
            data-type="number"
            format="fixedPoint"
          />
          <dx-column
            data-field="not_ordered"
            caption="미수주수량"
            data-type="number"
            format="fixedPoint"
          />
          <dx-paging :page-size="20" />
          <dx-selection
            select-all-mode="page"
            show-check-boxes-mode="onClick"
            mode="multiple"
          />
          <dx-filter-row :visible="true" />
        </dx-data-grid>
      </template>
    </dx-popup>

    <dx-popup
      v-model:visible="vars.dlg.addItem.show"
      content-template="popup-content"
      title="품목찾기"
      :close-on-outside-click="true"
      :width="680"
      :height="500"
      :resize-enabled="true"
      @initialized="evt => methods.onGridInitialized(evt, 'find-item2-popup')"
    >
      <dx-toolbar-item
        widget="dxButton"
        toolbar="top"
        location="after"
        :options="{
          icon: 'add',
          text: '선택된 항목 추가',
          onClick: methods.addSelectedRows,
        }"
      />

      <template #popup-content>
        <dx-data-grid
          :on-initialized="evt => methods.onGridInitialized(evt, 'baseItem')"
          :data-source="vars.dataSource.baseItem"
          :show-borders="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :column-auto-width="true"
          :remote-operations="true"
        >
          <dx-column data-field="item_code" caption="품목코드" />
          <dx-column data-field="item_name" caption="품명" />
          <dx-column data-field="item_standard" caption="규격" />
          <dx-column
            data-field="client_item.client_item_code"
            caption="고객사품번"
          />
          <dx-column data-field="asset_type" caption="자산구분" />
          <dx-column
            data-field="basic_stock.available_stock"
            caption="가용재고"
            data-type="number"
            format="fixedPoint"
            :calculate-display-value="methods.availableStock"
          />
          <dx-column
            data-field="basic_stock.current_stock"
            caption="현재고"
            data-type="number"
            format="fixedPoint"
            :calculate-display-value="methods.currentStock"
          />
          <dx-paging :page-size="20" />
          <dx-selection
            select-all-mode="page"
            show-check-boxes-mode="onClick"
            mode="multiple"
          />
          <dx-filter-row :visible="true" />
        </dx-data-grid>
      </template>
    </dx-popup>

    <dx-popup
      v-model:visible="vars.dlg.finder.show"
      content-template="popup-content"
      :title="vars.dlg.finder.title"
      :close-on-outside-click="true"
      :width="680"
      :height="500"
      :key="vars.dlg.finder.key"
      :resize-enabled="true"
      @initialized="evt => methods.onGridInitialized(evt, 'multiuse-popup')"
    >
      <template #popup-content>
        <data-grid-client
          v-if="vars.dlg.finder.key === 'client'"
          :filters="vars.dlg.finder.data"
          @change="methods.finderReturnHandler"
        />
        <data-grid-client
          v-else-if="vars.dlg.finder.key === 'enduser'"
          @change="methods.finderReturnHandler"
        />
        <data-grid-order
          v-else-if="vars.dlg.finder.key === 'order'"
          @change="methods.finderReturnHandler"
        />
        <data-grid-project
          v-else-if="vars.dlg.finder.key === 'project'"
          @change="methods.finderReturnHandler"
        />
        <data-grid-project
          v-else-if="vars.dlg.finder.key === 'project2'"
          @change="methods.finderReturnHandler"
        />
        <div v-else-if="vars.dlg.finder.key === 'etc'">
          <div class="mb-2">
            <dx-text-area
              :height="190"
              :value="vars.dlg.finder.data"
              @update:value="methods.updateEtcValue"
            />
          </div>
          <dx-toolbar>
            <dx-item
              widget="dxButton"
              toolbar="top"
              location="after"
              :options="{
                icon: null,
                text: '닫기',
                onClick: methods.finderReturnHandler,
              }"
            />
          </dx-toolbar>
        </div>
      </template>
    </dx-popup>

    <popup-item-detail
      v-model:visible="vars.itemDetail.visible"
      :item-id="vars.itemDetail.id"
    />
  </div>
</template>

<script>
import moment from 'moment';
import numeral from 'numeral';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import DxTextArea from 'devextreme-vue/text-area';
import {
  DxForm,
  DxLabel,
  DxGroupItem,
  DxSimpleItem,
  DxRequiredRule,
  DxCustomRule,
} from 'devextreme-vue/form';
import {
  DxDataGrid,
  DxColumn,
  DxSelection,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxScrolling,
  DxColumnChooser,
  DxLookup,
  DxToolbar as DxGridToolbar,
  DxItem as DxGridItem,
} from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue/button';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { confirm, alert } from 'devextreme/ui/dialog';
import { onMounted, ref, reactive, computed, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { getStock } from '../../data-source/setup';

import stateStore from '@/utils/state-store';
import {
  shipmentOrder,
  getShipmentOrderItem,
} from '../../data-source/shipment';
import {
  baseCodeLoader,
  getBaseItem,
  baseClient,
} from '../../data-source/base';
import {
  shipmentQuoteItem,
  getShipmentQuoteItem,
} from '../../data-source/shipment';
import { getProjectItem } from '../../data-source/project';
import DataGridClient from '../../components/base/data-client.vue';
import DataGridOrder from '../../components/shipment/data-order.vue';
import DataGridProject from '../../components/project/data-project.vue';
import authService from '../../auth';
import ApiService from '../../utils/api-service';
import {
  generateItemButtonOption,
  sumSupplyPrice,
  calcPriceSummary,
} from '../../utils/util';
import {
  loadDepartment,
  loadEmployee,
  loadClientManager,
  loadWarehouse,
} from '../../utils/data-loader';
import { notifyInfo, notifyError } from '../../utils/notify';
import PopupItemDetail from '@/components/base/popup-item-detail';

export default {
  components: {
    DxRequiredRule,
    DxCustomRule,
    DxToolbar,
    DxItem,
    DxTextArea,
    DxLoadPanel,
    DxForm,
    DxLabel,
    DxLookup,
    DxGroupItem,
    DxSimpleItem,
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxSelection,
    DxPaging,
    DxPopup,
    DxToolbarItem,
    DxFilterRow,
    DxScrolling,
    DxColumnChooser,
    DxGridToolbar,
    DxGridItem,
    DxButton,
    DataGridClient,
    DataGridOrder,
    DataGridProject,
    PopupItemDetail,
  },
  props: {
    id: [String, Number],
  },
  setup(props) {
    // variable 설정
    const router = useRouter();
    const vars = { dlg: {} };
    const updateStockApiService = new ApiService('/api/mes/v1/update-stock');
    vars.init = ref(false);
    vars.loading = ref(false);
    vars.formState = reactive({ readOnly: true });
    vars.grid = { baseItem: null, quoteItem: null, item1: null };
    vars.dlg.addItem = reactive({ show: false });
    vars.dlg.addQuoteItem = reactive({ show: false });
    vars.dlg.addProjectItem = reactive({ show: false });
    vars.dlg.finder = reactive({
      show: false,
      title: '',
      key: null,
      data: null,
    });
    vars.warehouse = {};
    vars.focus = {
      item1: null,
    };
    vars.filter = {
      baseItem: {
        clientId: null,
      },
      quoteItem: {
        clientCompany: null,
      },
      item1: [{ name: 'fk_order_id', op: 'eq', val: props.id || 0 }],
    };
    vars.disabled = reactive({
      edit: true,
      new: false,
      delete: true,
      save: true,
      items: true,
      manager: true,
      clientManager: true,
      tradeYn: false,
    });
    vars.dataSource = reactive({
      payment_terms: [],
      order_type: [],
      vat_type: [],
      delivery_place: [],
      warehouse: [],
      client_manager: [],
      department: [],
      employee: [],
      baseItem: null,
      quoteItem: null,
      item1: getShipmentOrderItem(vars.filter.item1),
    });
    vars.formData = reactive({});

    vars.summary = {};
    vars.summary.supply_price = computed(
      () => '₩' + numeral(vars.formData.supply_price).format('0,0')
    );
    vars.summary.vat = computed(
      () => '₩' + numeral(vars.formData.vat).format('0,0')
    );
    vars.summary.total_price = computed(
      () => '₩' + numeral(vars.formData.total_price).format('0,0')
    );

    vars.itemDetail = reactive({ visible: false, id: 0 });

    onMounted(async () => {
      await loadDepartment(vars.dataSource);
      await methods.loadBaseCode();
      methods.initById(props.id);
      methods.loadProjectItem();
      loadWarehouse(vars.dataSource);
    });

    // public methods
    const methods = {
      async initById(id) {
        methods.gridItem1Refresh(id);
        if (!id) {
          methods.clearFormData();

          vars.disabled.edit = true;
          vars.disabled.delete = true;
          vars.disabled.save = true;
          vars.disabled.items = true;
          vars.disabled.manager = true;
          vars.disabled.clientManager = true;
          return;
        }

        let { data } = await shipmentOrder.byKey(id);
        Object.assign(vars.formData, data);

        methods.enableDelete();
        vars.disabled.edit = false;
        if (vars.formData.client_company && vars.formData.order_department) {
          methods.enableSave();
          vars.disabled.items = false;
        }

        if (vars.formData.confirmed) {
          vars.disabled.edit = true;
          vars.disabled.delete = true;
          vars.disabled.save = true;
          vars.disabled.items = true;
          vars.disabled.manager = true;
          vars.disabled.clientManager = true;
        }

        methods.onClientChanged();
      },
      clearFormData() {
        vars.formData.id = null;
        vars.formData.created = null;
        vars.formData.order_number = '';
        vars.formData.order_date = '';
        vars.formData.client_company = '';
        vars.formData.client_manager = '';
        vars.formData.order_department = '';
        vars.formData.order_manager = '';
        vars.formData.order_type = '';
        vars.formData.vat_type = '';
        vars.formData.payment_terms = '';
        vars.formData.delivery_date = '';
        vars.formData.delivery_place = '';
        vars.formData.client_order_number = '';
        vars.formData.project_number = '';
        vars.formData.end_user = '';
        vars.formData.note = '';
        vars.formData.etc = '';
        vars.formData.supply_price = 0;
        vars.formData.vat = 0;
        vars.formData.total_price = 0;
        vars.formData.confirmed = false;
        vars.formData.fk_company_id = authService.getCompanyId();
      },
      async addSelectedRows() {
        const grid = vars.grid.item1;
        const rows = await vars.grid.baseItem.getSelectedRowsData();
        for (let row of rows) {
          const clientItemNumber = row.client_item
            ? row.client_item.client_item_code
            : null;
          const basicStock = row.basic_stock
            ? { ...row.basic_stock }
            : {
                current_stock: 0,
                available_stock: 0,
              };

          await grid.addRow();
          const data = await grid.byKey(grid.getKeyByRowIndex(0));
          data.item_code = row.item_code; // 품목코드
          data.item = { ...row }; // 품목
          data.supply_price = row.supply_price ? row.supply_price : 0; // 공급가
          data.order_quantity = 0; // 수주수량
          data.assign_quantity = 0; // 할당수량
          data.not_shipped = 0; // 미출고
          data.unit_price = row.sales_price; // 단가
          data.request_delivery_date = null; // 요청납기
          data.basic_stock = { ...basicStock }; // 기초재고
          data.client_item_number = clientItemNumber; // 공급사품번
          data.quote_number = null; // 견적번호
          data.note = ''; // 참고사항
          data.closing_yn = false; // 종결
          data.warehouse = { ...vars.warehouse }; // 출고창고
          data.warehouse_code = vars.warehouse.wh_code; // 창고코드
          data.project_number = vars.formData.project_number; // 프로젝트번호
          data.fk_quote_item_id = null; // 견적품목 아이디
          data.fk_order_id = vars.formData.id; // 수주 아이디
        }
        vars.dlg.addItem.show = false;
        methods.calcSummary();
      },
      async addSelectedQuoteRows() {
        const grid = vars.grid.item1;
        const rows = await vars.grid.quoteItem.getSelectedRowsData();
        for (let row of rows) {
          const basicStock = row.basic_stock
            ? { ...row.basic_stock }
            : {
                current_stock: 0,
                available_stock: 0,
              };

          let assignQuantity = row.quote_quantity;
          if (basicStock.available_stock < row.quote_quantity) {
            assignQuantity = basicStock.available_stock;
          }

          await grid.addRow();
          const data = await grid.byKey(grid.getKeyByRowIndex(0));
          data.item_code = row.item_code; // 품목코드
          data.item = { ...row.item }; // 품목
          data.supply_price = row.supply_price ? row.supply_price : 0; // 공급가
          data.order_quantity = row.quote_quantity; // 수주수량
          data.assign_quantity = assignQuantity; // 할당수량
          data.not_shipped = row.quote_quantity; // 미출고
          data.unit_price = row.unit_price; // 단가
          data.request_delivery_date = null; // 요청납기
          data.basic_stock = { ...basicStock }; // 기초재고
          data.client_item_number = row.client_item_number; // 공급사품번
          data.quote_number = row.quote.quote_number; // 견적번호
          data.note = row.note; // 참고사항
          data.closing_yn = false; // 종결
          data.warehouse = { ...row.warehouse }; // 출고창고
          data.warehouse_code = row.warehouse.wh_code; // 창고코드
          data.project_number = row.project_number; // 프로젝트번호
          data.fk_quote_item_id = row.id; // 견적품목 아이디
          data.fk_order_id = vars.formData.id; // 수주 아이디
        }
        vars.dlg.addQuoteItem.show = false;
        methods.calcSummary();
      },
      async addSelectedProjectRows() {
        const grid = vars.grid.item1;
        const rows = await vars.grid.projectItem.getSelectedRowsData();
        for (let row of rows) {
          const clientItemNumber = row.item.client_item
            ? row.item.client_item.client_item_code
            : null;
          const basicStock = row.basic_stock
            ? { ...row.basic_stock }
            : {
                current_stock: 0,
                available_stock: 0,
              };

          let assignQuantity = row.not_ordered;
          if (basicStock.available_stock < row.not_ordered) {
            assignQuantity = basicStock.available_stock;
          }

          await grid.addRow();
          const data = await grid.byKey(grid.getKeyByRowIndex(0));
          data.item_code = row.item_code; // 품목코드
          data.item = { ...row.item }; // 품목
          data.supply_price = row.supply_price ? row.supply_price : 0; // 공급가
          data.order_quantity = row.not_ordered; // 수주수량
          data.assign_quantity = assignQuantity; // 할당수량
          data.not_shipped = row.not_ordered; // 미출고
          data.unit_price = row.item.sales_price; // 단가
          data.request_delivery_date = null; // 요청납기
          data.basic_stock = { ...basicStock }; // 기초재고
          data.client_item_number = clientItemNumber; // 공급사품번
          data.quote_number = null; // 견적번호
          data.note = ''; // 참고사항
          data.closing_yn = false; // 종결
          data.warehouse = { ...vars.warehouse }; // 출고창고
          data.warehouse_code = vars.warehouse.wh_code; // 창고코드
          data.project_number = row.project.project_number; // 프로젝트번호
          data.fk_quote_item_id = null; // 견적품목 아이디
          data.fk_order_id = vars.formData.id; // 수주 아이디
          data.fk_project_item_id = row.id; // 프로젝트 품목 아이디
        }
        vars.dlg.addProjectItem.show = false;
        methods.calcSummary();
      },
      createFindPopupFn(key, title, data = null) {
        const _key = key,
          _title = title,
          _data = data;
        return () => {
          vars.dlg.finder.key = _key;
          vars.dlg.finder.data = _data;
          vars.dlg.finder.title = _title;
          vars.dlg.finder.show = true;
        };
      },
      showAddPopup() {
        if (vars.grid.baseItem) {
          vars.grid.baseItem.clearSelection();
          vars.grid.baseItem.refresh();
        }
        vars.dlg.addItem.show = true;
      },
      showAddQuotePopup() {
        const notContains = [];
        for (const item of vars.grid.item1.getVisibleRows()) {
          if (!item.id) {
            notContains.push(['id', '<>', item.data.fk_quote_item_id], 'and');
          }
        }
        notContains.pop()

        if (vars.grid.quoteItem) {
          vars.grid.quoteItem.filter(notContains);
          vars.grid.quoteItem.clearSelection();
          vars.grid.quoteItem.refresh();
        }
        vars.dlg.addQuoteItem.show = true;
      },
      showAddProjectPopup() {
        methods.loadProjectItem();

        const notContains = [];
        for (const item of vars.grid.item1.getVisibleRows()) {
          if (!item.id) {
            notContains.push(['id', '<>', item.data.fk_project_item_id], 'and');
          }
        }
        notContains.pop()

        if (vars.grid.projectItem) {
          vars.grid.projectItem.filter(notContains);
          vars.grid.projectItem.clearSelection();
          vars.grid.projectItem.refresh();
        }
        vars.dlg.addProjectItem.show = true;
      },
      async calculateAssignQuantity() {
        const rows = vars.grid.item1.getVisibleRows();
        for (const row of rows) {
          if (row.data.id) {
            const params = {
              order_item_id: row.data.id,
              item_code: row.data.item_code,
              warehouse: row.data.warehouse_code,
            };
            await updateStockApiService.post('', params);
          }
        }
        vars.grid.item1.refresh();
      },
      async gridItem1Refresh(id) {
        if (!id) id = 0;
        vars.filter.item1[0].val = id;
        vars.dataSource.item1.defaultFilters = vars.filter.item1;
        if (vars.grid.item1) {
          vars.grid.item1.cancelEditData();
          vars.grid.item1.refresh();
        }
      },
      onGridInitialized(evt, key) {
        vars.grid[key] = evt.component;
        stateStore.bind(`shipment-order-${key}`, evt.component);
      },
      async newItem() {
        methods.gridItem1Refresh();
        if (vars.formData.id) {
          methods.clearFormData();
          methods.redirect();
        }
        setTimeout(() => {
          methods.clearFormData();
          vars.formData.order_date = new Date();
          vars.formData.order_department = authService.getDepartmentName();
          vars.formData.order_manager = authService.getUserName();
          vars.formData.order_type = methods.getFirstOrderType();
          vars.formData.vat_type = methods.getFirstVatType();
          vars.formData.payment_terms = methods.getFirstPaymentTerms();
          vars.formData.delivery_place = methods.getFirstDeliveryPlace();
          vars.formData.fk_company_id = authService.getCompanyId();
          vars.formState.readOnly = false;
        }, 200);
      },
      async editItem() {
        if (!vars.formData.id) return;
        if (vars.formState.readOnly && vars.formData.confirmed) return;
        if (vars.formState.readOnly) {
          let isSelect = await confirm('수정하시겠습니까?', '수정');
          if (!isSelect) {
            return;
          }
        }

        const saveFormData = Object.assign({}, vars.formData);
        vars.formState.readOnly = !vars.formState.readOnly;

        methods.enableDelete();
        methods.enableSave();

        await nextTick();
        Object.assign(vars.formData, saveFormData);
      },
      async deleteItem() {
        const result = await confirm(
          '이 항목을 삭제하시겠습니까?',
          '삭제 확인'
        );
        if (result) {
          try {
            await shipmentOrder.remove(vars.formData.id);
            await alert('삭제되었습니다', '삭제 확인');
            methods.redirect();
            vars.formState.readOnly = true;
          } catch (ex) {
            if (ex.response.status != 403) {
              await alert(
                '연결된 데이터가 있어서 삭제가 안됩니다',
                '삭제 확인'
              );
            }
          }
        }
      },
      async saveItem() {
        vars.loading.value = true;
        try {
          if (vars.formData.id) {
            // 기존 정보 업데이트
            const updateDate = Object.assign({}, vars.formData);
            delete updateDate.created;
            delete updateDate.order_number;
            const { data } = await shipmentOrder.update(
              vars.formData.id,
              updateDate
            );
            vars.formData.order_number = data.order_number;
            if (vars.grid.item1) await vars.grid.item1.saveEditData();

            vars.formState.readOnly = true;
            notifyInfo('저장되었습니다');

            methods.enableSave();
            methods.enableDelete();
          } else {
            // 채번이 없을 경우 자동 채번
            if (vars.formData.created) vars.formData.created = null;
            let { data } = await shipmentOrder.insert(vars.formData);
            vars.formData.id = data.id;

            const gridItem1 = vars.grid.item1;
            if (gridItem1 && gridItem1.hasEditData()) {
              await gridItem1.saveEditData();
            }

            methods.redirect(data.id);
            vars.formState.readOnly = true;
            notifyInfo('저장되었습니다');
          }
        } catch (ex) {
          if (ex.response.status === 409) {
            notifyError('이미 존재하는 수주번호 입니다');
          } else {
            console.error(ex);
            notifyError('저장 할 내용이 없습니다');
          }
        } finally {
          vars.loading.value = false;
        }
      },
      finderReturnHandler(data) {
        switch (vars.dlg.finder.key) {
          case 'order': {
            methods.redirect(data.id);
            vars.formState.readOnly = true;
            break;
          }
          case 'client': {
            vars.formData.client_company = data.name;
            methods.onClientChanged();
            break;
          }
          case 'enduser': {
            vars.formData.end_user = data.name;
            break;
          }
          case 'project': {
            vars.formData.project_number = data.project_number;
            if (
              data.order_company &&
              data.order_company != vars.formData.client_company
            ) {
              vars.formData.client_company = data.order_company;
              if (vars.formData.client_company) {
                methods.onClientChanged();
              }
            }
            break;
          }
          case 'project2': {
            vars.focus.item1.component.cellValue(
              vars.focus.item1.rowIndex,
              vars.focus.item1.columnIndex,
              data.project_number
            );
            break;
          }
          case 'etc': {
            console.log(vars.dlg.finder.data);
            vars.formData.etc = vars.dlg.finder.data;
            break;
          }
        }

        vars.dlg.finder.show = false;
        vars.dlg.finder.title = '';
        vars.dlg.finder.key = null;
        vars.dlg.finder.data = null;
      },
      async onClientChanged() {
        const inputValue = vars.formData.client_company;
        const { data } = await baseClient.load({
          filter: [
            ['fk_company_id', '=', authService.getCompanyId()],
            ['name', '=', inputValue],
          ],
          take: 1,
          skip: 0,
        });
        const client = data.length > 0 ? data[0] : null;

        vars.filter.baseItem.clientId = client ? client.id : null;
        methods.loadBaseItem();

        vars.filter.quoteItem.clientCompany = client ? client.name : null;
        methods.loadQuoteItem();

        if (!client) {
          vars.disabled.edit = true;
          vars.disabled.delete = true;
          vars.disabled.save = true;
          vars.disabled.items = true;
          vars.disabled.tradeYn = false;
          vars.disabled.clientManager = true;
          vars.formData.client_manager = null;
          vars.dataSource.client_manager = [];
        } else {
          if (vars.formState.readOnly || vars.disabled.tradeYn) {
            loadClientManager(vars.dataSource, client.name);
            vars.disabled.tradeYn = false;
            vars.disabled.clientManager = false;
          } else {
            let isSelect = true;
            if (client.trade_yn) {
              isSelect = await confirm(
                '거래중지 업체입니다. 계속 진행하시겠습니까?',
                '고객업체'
              );
            }
            if (isSelect) {
              loadClientManager(vars.dataSource, client.name);
              vars.disabled.clientManager = false;
              vars.formData.client_manager = null;
            } else {
              vars.formData.client_company = '';
              vars.disabled.tradeYn = true;
              vars.formData.client_manager = null;
            }
          }
        }
        methods.checkPossibleSave();
      },
      async onEndUserChanged(e) {
        if (vars.formState.readOnly) {
          return;
        }
        const client = e.component.option('selectedItem');
        if (client) {
          if (client.trade_yn && !vars.disabled.tradeYn) {
            const result = await confirm(
              '거래중지 업체입니다. 계속 진행하시겠습니까?',
              'EndUser'
            );
            if (!result) {
              vars.formData.end_user = e.previousValue;
              vars.disabled.tradeYn = true;
              return;
            }
          }
        }
        vars.disabled.tradeYn = false;
      },
      async onConfirmChanged(e) {
        if (!vars.formData.id) {
          return;
        }
        if (e.value) {
          vars.formState.readOnly = true;
          vars.disabled.edit = true;
          vars.disabled.delete = true;
          vars.disabled.items = true;
        } else {
          if (vars.formData.client_company && vars.formData.order_department) {
            vars.disabled.edit = false;
            vars.disabled.items = false;
            methods.enableSave();
            methods.enableDelete();
          }
        }
      },
      updateEtcValue(v) {
        vars.dlg.finder.data = v;
      },
      onDepartmentChanged(e) {
        if (!e.value) {
          vars.disabled.save = true;
          vars.disabled.items = true;
          vars.disabled.manager = true;
          vars.formData.order_manager = null;
          vars.dataSource.employee = [];
        } else {
          const selectItem = e.component.option('selectedItem');
          if (selectItem) {
            loadEmployee(vars.dataSource, selectItem.id);
            vars.disabled.manager = false;
          }
        }
        methods.checkPossibleSave();

        const selectedItem = e.component.option('selectedItem');
        if (selectedItem) {
          vars.warehouse = { ...selectedItem.warehouse };
        } else {
          vars.warehouse = {};
        }
        methods.loadBaseItem();
        methods.loadQuoteItem();
      },
      onSavingItem(e) {
        e.changes.forEach(element => {
          if (element.type != 'remove') {
            element.data.fk_order_id = vars.formData.id;
            delete element.data.item;
            delete element.data.warehouse;
            delete element.data.basic_stock;
          }
        });
        methods.saveSummary();
      },
      saveSummary() {
        const priceData = {
          supply_price: vars.formData.supply_price,
          vat: vars.formData.vat,
          total_price: vars.formData.total_price,
        };
        shipmentOrder.update(vars.formData.id, priceData);
      },
      onDataError(e) {
        if (e.error.response.status == 605) {
          e.error.message = '연결된 데이터가 있어서 삭제가 안됩니다';
        } else if (e.error.response.status == 606) {
          e.error.message = '출고수량이 현재고를 초과했습니다';
        } else if (e.error.response.status == 607) {
          e.error.message = '기초재고가 등록되지 않은 품목입니다';
        } else if (e.error.response.status == 403) {
          e.error.message = '권한이 없습니다';
        }
      },
      onFocusedCellChanged(e) {
        vars.focus.item1 = e;
      },
      availableStock(rowData) {
        if (!rowData.basic_stock) return '0';
        return rowData.basic_stock.available_stock;
      },
      currentStock(rowData) {
        if (!rowData.basic_stock) return '0';
        return rowData.basic_stock.current_stock;
      },
      setQuantity(newData, value, currentRowData) {
        const {
          not_shipped,
          order_quantity,
          unit_price,
          basic_stock,
          closing_yn,
        } = currentRowData;

        newData.not_shipped = not_shipped + (value - order_quantity);
        newData.order_quantity = value;
        newData.unit_price = unit_price;
        if (closing_yn || !basic_stock) {
          newData.assign_quantity = 0;
        } else {
          if (basic_stock.available_stock >= newData.not_shipped) {
            newData.assign_quantity = newData.not_shipped;
          } else {
            newData.assign_quantity = basic_stock.available_stock;
          }
        }
        newData.supply_price = newData.order_quantity * newData.unit_price;
        methods.calcSummary();
      },
      setUnitPrice(newData, value, currentRowData) {
        newData.order_quantity = currentRowData.order_quantity;
        newData.unit_price = value;
        newData.supply_price = newData.order_quantity * newData.unit_price;
        methods.calcSummary();
      },
      calcSummary() {
        setTimeout(() => {
          let total = sumSupplyPrice(
            vars.grid.item1,
            'order_quantity',
            'unit_price'
          );
          const response = calcPriceSummary(vars.formData.vat_type, total);
          vars.formData.supply_price = response.supply_price;
          vars.formData.vat = response.vat;
          vars.formData.total_price = response.total_price;
        }, 200);
      },
      async setWarehouse(newData, value, currentRowData) {
        const warehouseList = vars.dataSource.warehouse;
        for (let i = 0; i < warehouseList.length; i++) {
          if (warehouseList[i].wh_name == value) {
            newData.warehouse = {};
            Object.assign(newData.warehouse, warehouseList[i]);
            newData.warehouse_code = warehouseList[i].wh_code;

            const { basicStock } = await getStock(
              currentRowData.item_code,
              newData.warehouse_code
            );
            newData.basic_stock = {
              current_stock: basicStock.current_stock,
              available_stock: basicStock.available_stock,
            };

            if (currentRowData.closing_yn || !basicStock) {
              newData.assign_quantity = 0;
            } else {
              if (basicStock.available_stock >= currentRowData.not_shipped) {
                newData.assign_quantity = currentRowData.not_shipped;
              } else {
                newData.assign_quantity = basicStock.available_stock;
              }
            }
            break;
          }
        }
      },
      loadBaseCode() {
        return baseCodeLoader([
          '부가세구분',
          '수주구분',
          '결재조건',
          '납품장소',
        ])
          .then(response => {
            vars.dataSource.payment_terms = response['결재조건'];
            vars.dataSource.order_type = response['수주구분'];
            vars.dataSource.vat_type = response['부가세구분'];
            vars.dataSource.delivery_place = response['납품장소'];
          })
          .then(() => (vars.init.value = true));
      },
      loadBaseItem() {
        vars.dataSource.baseItem = getBaseItem(
          null,
          vars.filter.baseItem.clientId,
          vars.warehouse.wh_code
        );
      },
      loadQuoteItem() {
        vars.dataSource.quoteItem = getShipmentQuoteItem([
          {
            name: 'quote',
            op: 'has',
            val: {
              name: 'client_company',
              op: 'eq',
              val: vars.filter.quoteItem.clientCompany,
            },
          },
        ]);
      },
      loadProjectItem() {
        vars.dataSource.projectItem = getProjectItem([
          {
            name: 'project',
            op: 'has',
            val: {
              name: 'project_number',
              op: 'eq',
              val: vars.formData.project_number,
            },
          },
          {
            name: 'not_ordered',
            op: 'gt',
            val: 0,
          },
        ]);
      },
      checkPossibleSave() {
        if (
          vars.formData.client_company &&
          vars.formData.order_department &&
          !vars.formData.confirmed
        ) {
          methods.enableSave();
          vars.disabled.items = false;
        }
      },
      getFirstOrderType() {
        return methods.getFirstItemName(vars.dataSource.order_type);
      },
      getFirstVatType() {
        return methods.getFirstItemName(vars.dataSource.vat_type);
      },
      getFirstPaymentTerms() {
        return methods.getFirstItemName(vars.dataSource.payment_terms);
      },
      getFirstDeliveryPlace() {
        return methods.getFirstItemName(vars.dataSource.delivery_place);
      },
      getFirstItemName(itemList) {
        if (!itemList || itemList.length < 0) return '';
        else return itemList[0].code_name;
      },
      redirect(id) {
        if (id) router.replace({ path: `/shipment/order/${id}` });
        else router.replace({ path: `/shipment/order` });
      },
      itemPopupClick({ column, data }) {
        if (column.name === 'item_code') {
          vars.itemDetail.id = data.item.id;
          vars.itemDetail.visible = true;
        }
      },
      onVatTypeChanged(e) {
        methods.calcSummary();
      },
      enableDelete() {
        if (vars.formState.readOnly) {
          vars.disabled.delete = true;
        } else {
          vars.disabled.delete = false;
        }
      },
      enableSave() {
        if (vars.formState.readOnly) {
          vars.disabled.save = true;
        } else {
          vars.disabled.save = false;
        }
      },
    };

    watch(
      () => props.id,
      () => methods.initById(props.id)
    );

    return {
      vars,
      methods,
      shipmentQuoteItem,
      generateItemButtonOption,
    };
  },
};
</script>
<style>
.popup-message {
  text-align: center;
}
</style>
